module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Blacklisted Originators")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "Blacklist Originator",
      "placement": "left"
    }
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Listeners who's messages we'd like to ban from showing on our interaction panels.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content blacklist-list-content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.blacklistedOriginators,
      "fit": true,
      "default-sort": {
        prop: 'title'
      },
      "row-key": "id",
      "max-height": "400",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "originator",
      "label": "Originator",
      "width": "200",
      "class-name": "client-link"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "content": "Edit",
            "placement": "right"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              return _vm.editBlacklistedOriginator(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.originator))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "date_created",
      "label": "Date Added",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.date_created, "Do MMM YYYY")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          attrs: {
            "trigger": "hover",
            "placement": "bottom"
          },
          on: {
            "command": _vm.handleAction
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("\n                Actions\n                "), _c('i', {
          staticClass: "el-icon-arrow-down el-icon--right"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.editBlacklistedOriginator,
              item: scope.row
            }
          }
        }, [_vm._v("Edit")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": {
              action: _vm.deleteBlacklistedOriginator,
              item: scope.row
            }
          }
        }, [_vm._v("Delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": this.isNewBlacklistOriginator ? 'Blacklist Originator' : 'Edit Blacklisted Originator',
      "visible": _vm.showEditDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditDialog = $event
      }
    }
  }, [(_vm.showEditDialog) ? _c('blacklist-originator-edit', {
    attrs: {
      "originator": _vm.selectedBlacklistedOriginator
    },
    on: {
      "cancel": function($event) {
        _vm.showEditDialog = false
      },
      "save": _vm.updateBlacklist
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateDialog) ? _c('blacklist-originator-create', {
    on: {
      "cancel": function($event) {
        _vm.showCreateDialog = false
      },
      "save": _vm.addBlacklistOriginator
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Blacklist Originator',
      "visible": _vm.showCreateDialog,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showCreateDialog = $event
      }
    }
  }, [(_vm.showCreateDialog) ? _c('blacklist-originator-create', {
    on: {
      "cancel": function($event) {
        _vm.showCreateDialog = false
      },
      "save": _vm.addBlacklistOriginator
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40575973","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/blacklist/BlacklistOriginatorList.vue
// module id = 3245
// module chunks = 3